import React from 'react';
import SequenceUploadWizard from './upload/SequenceUploadWizard';

interface SequenceUploadProps {
  onSuccess?: (sequenceId: string) => void;
  onCancel?: () => void;
  onStepChange?: (currentStep: number) => void;
}

const SequenceUpload: React.FC<SequenceUploadProps> = ({ onSuccess, onCancel, onStepChange }) => {
  return <SequenceUploadWizard onSuccess={onSuccess} onCancel={onCancel} onStepChange={onStepChange} />;
};

export default SequenceUpload;